import AppLayout from '../layouts/AppLayout'

export const settings = {
  path: '/menu',
  name: 'menu.index',
  component: AppLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'profile',
      name: 'menu.profile.index',
      component: () =>
        import(
          /* webpackChunkName: "menu.profile.index" */ '@/views/new-menu/menu-profile/Index.vue'
        ),
      meta: {
        title: 'Menu Perfil',
        breadcrumb: [
          {
            text: 'dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Menu Perfil'
          }
        ]
      }
    },
    {
      path: 'user',
      name: 'menu.user.index',
      component: () =>
        import(
          /* webpackChunkName: "menu.user.index" */ '@/views/new-menu/menu-user/Index.vue'
        ),
      meta: {
        title: 'Menu Usuario',
        breadcrumb: [
          {
            text: 'dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Menu Usuario'
          }
        ]
      }
    }
  ]
}
